import React, { Component } from "react";
import "./Menu.scss";
import {
  MenuItem,
  withEventDispatcher,
  EventSource,
  translate,
  ModuleMessaging
} from "clavis-nxt-components-custdevtm";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuCollapsed: null,
      focus: false,
      menuItems: [],
      isMenuOpened: true
    };
    let environment = JSON.parse(localStorage.getItem("environment"));
    this.applicationVersion = environment.applicationVersion;
  }

  handleMenuItemsEvent = payload => {
    const newItemList = [payload.menuItemName, ...this.state.menuItems];
    this.setState({ menuItems: newItemList });
  };

  handleChangedMenuSize = () => {
    this.sendMenuCollapsedStateMessage(!this.state.isMenuOpened);
    this.setState({ isMenuOpened: !this.state.isMenuOpened });
  };

  sendMenuCollapsedStateMessage = state => {
    ModuleMessaging.dispatchEvent("web-platform", "MenuCollapsedState", {
      isOpened: state
    });
  };

  componentDidMount() {
    this.props.eventDispatcher.subscribe(
      "web-platform",
      "GetMenuCollapsedState",
      EventSource.CLIENT,
      () => {
        this.sendMenuCollapsedStateMessage(this.state.isMenuOpened);
      }
    );

    if (document.getElementById("menu-size-button") != null) {
      document
        .getElementById("menu-size-button")
        .addEventListener("changeMenuSize", this.handleChangedMenuSize, false);
    } else {
      console.error("menu-size-button is not found...");
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div
        id="menu-container"
        className={
          "menu-container menu-background-color menu-text-color " +
          (this.props.notification
            ? "with-notification"
            : "without-notification") +
          (!this.state.isMenuOpened ? " minimalized" : "")
        }
      >
        <div className="menu-list">
          <MenuItem
            text={t("platform.Menu.welcome")}
            icon="icon-dashboard icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/welcome"
            mainPrivilige="ui_menu_dashboard"
          />
          <MenuItem
            text={t("cdt.message.title")}
            icon="icon-Message icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/message"
            mainPrivilige="ui_menu_message_read"
          />
          <MenuItem
            text={t("cdt.profile")}
            icon="icon-members icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/profile"
            mainPrivilige="ui_menu_profile_read"
            child={[
              {
                name: t("cdt.profile.profile"),
                route: "/nxt/custdevtm/profile",
                privilege: "ui_menu_profile_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/profile"
              },
              {
                name: t("pls.profile.ownLog"),
                route: "/nxt/custdevtm/ownLog",
                privilege: "ui_menu_own_log_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/ownLog"
              },
              {
                name: t("cdt.contractorProfile.title"),
                route: "/nxt/custdevtm/contractorProfile",
                privilege: "ui_menu_contractor_profile_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/contractorProfile"
              },
              {
                name: t("cdt.ownUser"),
                route: "/nxt/custdevtm/ownUser",
                privilege: "ui_menu_own_user_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/ownUser"
              }
            ]}
          />
          <MenuItem
            text={t("cdt.report")}
            icon="icon-reports icon-normal"
            menuVisible={this.state.isMenuOpened}
            mainPrivilige="ui_menu_report_read"
            child={[
              {
                name: t("cdt.report.availableCover"),
                privilege: "ui_menu_available_cover_report_read",
                route: "/nxt/custdevtm/availableCoverReport",
                key: "/nxt/custdevtm/availableCoverReport"
              },
              {
                name: t("cdt.report.deficit"),
                privilege: "ui_menu_deficit_report_read",
                route: "/nxt/custdevtm/deficitReport",
                key: "/nxt/custdevtm/deficitReport"
              },
              {
                name: t("cdt.report.deduction"),
                privilege: "ui_menu_deduction_report_read",
                route: "/nxt/custdevtm/deductionReport",
                key: "/nxt/custdevtm/deductionReport"
              },
              {
                name: t("cdt.report.coverStatus"),
                privilege: "ui_menu_cover_status_report_read",
                route: "/nxt/custdevtm/coverStatusReport",
                key: "/nxt/custdevtm/coverStatusReport"
              },
              {
                name: t("cdt.report.bankGuarantee"),
                privilege: "ui_menu_bank_guarantee_report_read",
                route: "/nxt/custdevtm/bankGuarantee",
                key: "/nxt/custdevtm/bankGuarantee"
              }
            ]}
          />
          <MenuItem
            text={t("cdt.exchangeRate.title")}
            icon="icon-swap icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/exchangeRate"
            mainPrivilige="ui_menu_exchange_rate"
          />
          <MenuItem
            text={t("platform.Menu.manual")}
            icon="icon-cp-add-new-package icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/manual"
            mainPrivilige="ui_menu_manual_read"
          />
          <MenuItem
            text={t("platform.Menu.admin")}
            icon="icon-settings icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/user"
            mainPrivilige="ui_menu_translation_read"
            child={[
              {
                name: t("cdt.user.title"),
                route: "/nxt/custdevtm/user",
                privilege: "ui_menu_user_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/user"
              },
              {
                name: t("cdt.contractor.title"),
                route: "/nxt/custdevtm/contractor",
                privilege: "ui_menu_contractor_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/contractor"
              },
              {
                name: t("pls.admin.operationFullLog"),
                privilege: "ui_menu_operation_log",
                route: "/nxt/custdevtm/operationLog",
                key: "/nxt/custdevtm/operationLog"
              },
              {
                name: t("pls.menu.allMessages"),
                privilege: "ui_menu_message_read",
                route: "/nxt/custdevtm/allMessages",
                key: "/nxt/custdevtm/allMessages"
              },
              {
                name: t("cdt.governmentOffice.title"),
                route: "/nxt/custdevtm/governmentOffice",
                privilege: "ui_menu_government_office_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/governmentOffice"
              },
              {
                name: t("cdt.country.title"),
                route: "/nxt/custdevtm/country",
                privilege: "ui_menu_countries",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/country"
              },
              {
                name: t("cdt.county.title"),
                route: "/nxt/custdevtm/county",
                privilege: "ui_menu_county_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/county"
              },
              {
                name: t("cdt.city.title"),
                route: "/nxt/custdevtm/city",
                privilege: "ui_menu_city_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/city"
              },
              {
                name: t("platform.Menu.calendar"),
                privilege: "ui_menu_calendar",
                route: "/nxt/clockwork/calendars",
                key: "/nxt/custdevtm/calendars"
              },
              {
                name: t("platform.Menu.document"),
                privilege: "ui_menu_document_read",
                route: "/nxt/custdevtm/document",
                key: "/nxt/custdevtm/document"
              }
            ]}
          />
          <MenuItem
            text={t("pls.admin.systemAdmin")}
            icon="icon-admin icon-normal"
            menuVisible={this.state.isMenuOpened}
            route="/nxt/custdevtm/systemAdmin"
            mainPrivilige="ui_menu_other_dictionary_read"
            child={[
              {
                name: t("cdt.companyType.title"),
                route: "/nxt/custdevtm/companyType",
                privilege: "ui_menu_company_type_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/companyType"
              },
              {
                name: t("cdt.countyType.title"),
                route: "/nxt/custdevtm/countyType",
                privilege: "ui_menu_county_type_read",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/countyType"
              },
              {
                name: t("cdt.exchangeRateType.title"),
                route: "/nxt/custdevtm/exchangeRateType",
                privilege: "ui_menu_exchange_rate_type",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/exchangeRateType"
              },
              {
                name: t("cdt.documentType.title"),
                route: "/nxt/custdevtm/documentType",
                privilege: "ui_menu_document_type",
                adminIcon: "icon-settings icon-normal",
                key: "/nxt/custdevtm/documentType"
              },
              {
                name: t("platform.Menu.configurationKeys"),
                privilege: "ui_menu_configuration_keys_read",
                route: "/nxt/configuration-keys",
                key: "/nxt/configuration-keys"
              },
              {
                name: t("cdt.messageTemplate.title"),
                privilege: "ui_menu_message_template_read",
                route: "/nxt/custdevtm/messageTemplate",
                key: "/nxt/custdevtm/messageTemplate"
              },
              {
                name: t("platform.Menu.translationAdmin"),
                privilege: "ui_menu_translation_read",
                route: "/nxt/translation",
                key: "/nxt/translation"
              },
              {
                name: t("platform.Menu.clockwork"),
                privilege: "ui_menu_clockwork",
                route: "/nxt/clockwork/clockwork",
                key: "/nxt/custdevtm/clockwork"
              }
            ]}
          />
        </div>
        <div className="version-info label-color tiny-font-regular ">
          {this.state.isMenuOpened ? (
            <div className="version">
              {t("platform.Menu.version")} {this.applicationVersion}
            </div>
          ) : (
            ""
          )}
          <i className="icon icon-info icon-small" />
        </div>
      </div>
    );
  }
}

export default translate()(withEventDispatcher(Menu));
